import { render, staticRenderFns } from "./vuse-beerpong.vue?vue&type=template&id=5650ad4b&scoped=true&"
import script from "./vuse-beerpong.vue?vue&type=script&lang=js&"
export * from "./vuse-beerpong.vue?vue&type=script&lang=js&"
import style0 from "./vuse-beerpong.vue?vue&type=style&index=0&id=5650ad4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650ad4b",
  null
  
)

export default component.exports